const RAW_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const INVALID_TOKEN_MARKERS = [
  "<SET_IN_DEPLOYMENT_ENV>",
  "<SET_MAPBOX_TOKEN>",
  "<MAPBOX_TOKEN>",
];

export const getMapboxToken = () => {
  const token = (RAW_TOKEN || "").trim();
  if (!token) return null;
  if (INVALID_TOKEN_MARKERS.includes(token)) return null;
  return token;
};

export const hasMapboxToken = () => Boolean(getMapboxToken());
